var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDocumentTextOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "document-text-outline",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40.195,
    height: 51.158,
    viewBox: "0 0 40.195 51.158",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_6",
    "data-name": "Path 6",
    d: "M14.808,3H26.085a5.445,5.445,0,0,1,3.874,1.6L46.09,20.736A5.446,5.446,0,0,1,47.7,24.611V46.85a7.317,7.317,0,0,1-7.308,7.308H14.808A7.317,7.317,0,0,1,7.5,46.85V10.308A7.317,7.317,0,0,1,14.808,3ZM40.387,50.5a3.658,3.658,0,0,0,3.654-3.654V24.611a1.815,1.815,0,0,0-.535-1.291L27.375,7.189a1.839,1.839,0,0,0-1.291-.534H14.808a3.658,3.658,0,0,0-3.654,3.654V46.85A3.658,3.658,0,0,0,14.808,50.5Z",
    transform: "translate(-7.5 -3)",
    fill: "#00828b"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7",
    "data-name": "Path 7",
    d: "M41.684,24.761h-13.7A5.487,5.487,0,0,1,22.5,19.28V5.577a1.827,1.827,0,0,1,3.654,0v13.7a1.829,1.829,0,0,0,1.827,1.827h13.7a1.827,1.827,0,1,1,0,3.654Z",
    transform: "translate(-4.229 -2.836)",
    fill: "#00828b"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_8",
    "data-name": "Path 8",
    d: "M35.1,29.154H16.827a1.827,1.827,0,0,1,0-3.654H35.1a1.827,1.827,0,1,1,0,3.654Z",
    transform: "translate(-5.865 1.906)",
    fill: "#00828b"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_9",
    "data-name": "Path 9",
    d: "M35.1,36.654H16.827a1.827,1.827,0,0,1,0-3.654H35.1a1.827,1.827,0,0,1,0,3.654Z",
    transform: "translate(-5.865 3.541)",
    fill: "#00828b"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDocumentTextOutline);
export default __webpack_public_path__ + "static/media/document-text-outline.33eefcf69e65ff85519b757591080095.svg";
export { ForwardRef as ReactComponent };